(($) => {
  $('.nice-select').niceSelect();

  goToStep("step-1");
  onClickNextButton();

  $(".form-all").on("submit", function(e){
    e.preventDefault();
    console.log("Enviando form...");
    // Passar os dados pro back aqui talvez... ou retirar o onSubmit
  })


  function onClickNextButton(){
    $(".form-all .form .button.next").on("click", function() {
      let isFormValid = true;
      let nextForm = $(this).attr("data-next");
      let formId = $(this).closest(".form").attr("id");
      let formFields = $(`.form-all .form#${formId} [name]`);

      formFields.each(function (index) {
        if(!checkRequired($(this))){
          return;
        }
        if(!checkMinLength($(this))){
          return;
        }
        if(!checkMaxLength($(this))){
          return;
        }
      })

      formFields = $(`.form-all .form#${formId} [name]`);

      formFields.each((index, field) => {
        let container = $(field).closest(".field-group");
        if(container.hasClass("error")){
          isFormValid = false;
          return false;
        }
      })

      if(isFormValid){
        return goToStep(nextForm);
      }
    })
  }
  function goToStep(step){
    hideAllSteps();
    removeActiveFromSteps();
    $(`.form-all .form#${step}`).addClass("show");
    $(`.step .step__item[data-step="${step}"]`).addClass("step__item--active");
  }
  function hideAllSteps(){
    $(`.form-all .form`).each(function() {
      $(this).removeClass("show");
    })
  }
  function removeActiveFromSteps(){
    $(`.step .step__item`).each(function() {
      $(this).removeClass("step__item--active");
    })
  }
  function checkRequired(element){
    let isRequired = element.is(":required");

    if(!isRequired)
      return setCallback(element, "success", "Okay!");

    if(element.val().length < 1)
      return setCallback(element, "error", "Este campo é obrigatório!");

    return setCallback(element, "success", "Okay!");
  }
  function checkMinLength(element){
    let minLength = element.attr("data-minlength");

    if(!minLength)
      return setCallback(element, "success", "Okay!");

    if(element.val().length < minLength)
      return setCallback(element, "error", `Preencha pelo menos ${minLength} caracteres!`);

    return setCallback(element, "success", "Okay!");
  }
  function checkMaxLength(element){
    let maxLength = element.attr("data-maxlength");

    if(!maxLength)
      return setCallback(element, "success", "Okay!");

    if(element.val().length > maxLength)
      return setCallback(element, "error", `Preencha no máximo ${maxLength} caracteres!`);

    return setCallback(element, "success", "Okay!");
  }
  function setCallback(element, type, message){
    let container = element.closest(".field-group");

    ["success", "warning", "error"].forEach((e) => {
      container.removeClass(e);
    });

    container.addClass(type);
    container.find(".callback")
      .text(message);

    return (type === "success");
  }

})(jQuery);
